import { FC } from 'react';

import AppLayout, { LayoutProps, Link } from 'app/components/layout/AppLayout';
import { keys } from 'app/config/keys';
import { adminRoutes, externalRoutes, routes } from 'app/constants/routes';
import { useQueryString } from 'app/state/NavigationContext/hooks';

// Local Variables
const redirectLegacyAdminPanel = () => window.location.href = `${keys.CORE_URL}/${externalRoutes.admin}`;

// Component Definition
const AdminRoutesLayout: FC<LayoutProps> = props => {
  const dashboardQueryString = useQueryString('adminDashboard');
  const selectCarrierQueryString = useQueryString('adminSelectCarriers');

  const links: Link[] = [
    {
      activePaths: [`/${routes.admin}/${adminRoutes.dashboard}`],
      iconName: 'home',
      id: 'dashboard',
      label: 'Dashboard',
      to: `/${routes.admin}/${adminRoutes.dashboard}${dashboardQueryString}`,
    },
    {
      activePaths: [`/${routes.admin}/${adminRoutes.selectCarriers}`],
      iconName: 'business',
      id: 'select-carriers',
      label: 'Select Carriers',
      to: `/${routes.admin}/${adminRoutes.selectCarriers}${selectCarrierQueryString}`,
    },
    {
      activePaths: [],
      iconName: 'file',
      id: 'admin-actions',
      label: 'Admin Actions',
      to: `/${routes.admin}/${adminRoutes.adminActions}`,
    },
    {
      activePaths: [],
      iconName: 'report',
      id: 'reports',
      label: 'Reports',
      to: `/${routes.admin}/${adminRoutes.reports}`,
    },
    // TODO: Remove once new admin panel is complete
    {
      activePaths: [],
      iconName: 'lock',
      id: 'admin',
      label: 'Admin',
      onClick: redirectLegacyAdminPanel,
    },
  ];

  return (
    <AppLayout
      body={props.body}
      logoPath="/"
      navLinks={links}
    />
  );
};

export default AdminRoutesLayout;
